import { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  PlanPopoverWrapper,
  SidebarGroupPanelWrapper,
  SidebarWrapper
} from "./styles";
import { ImageCustom, PlanBox } from "..";
import AvatarImage from "../../assets/images/temp/temp_avatar.png";
import IconSearch from "../../assets/images/sidebar/search_sidebar.png";
import IconChevronRight from "../../assets/images/sidebar/chevron-right.png";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  InputAdornment,
  Modal,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ArrowLeft from "../../assets/images/common/icon_arrow_left_line_black.svg";
import IconSidebarMenu from "../../assets/images/sidebar/icon_sidebar_menu.png";

import { sidebarItems } from "../../routes";
import { authTokens } from "../../services/services";
import RoleService from "../../services/api/role.service";
import { ITokenPayload, IUser } from "../../models/user";
import { IFeaturePermission } from "../../models/user/models.roles";
import { useApi } from "../../hooks/useApi.hook";
import useAxios from "../UseAxios/useAxios";
import WorkflowService from "../../services/api/workflow.service";
import { IWorkflowByTypeResponse } from "../../models/workflow";
import { ROUTE_PATH } from "../../common/constants/app.constant";
import useNavigateSearch from "../NavigateSearch";
import HomeIcon_1 from "../../assets/images/sidebar/Icon_home.png";
import HomeIcon from "../../assets/images/sidebar/icon_tong_quan.png";
import HomeIconActive from "../../assets/images/sidebar/icon_tong_quan.png";
import { EAlphabetColor, enumFromValue } from "../../models/common/models.enum";
import {
  AddRounded,
  ArrowDropDownRounded,
  Block,
  MenuRounded,
  QuestionAnswerRounded,
  RemoveRounded
} from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CreateWorkflowDialog from "../../pages/WorkflowManagement/components/CreateWorkflowDialog/create_workflow_dialog";
// import LogoImage from "../../assets/images/login/Logo-Miko-Tech.png";
// import LogoImage from "../../assets/images/login/Logo-Linkco-02.png";
// import LogoImage from "../../assets/images/login/Logo-LinkcoVN-option-1.png";
import LogoImage from "../../assets/images/login/logo.svg";
import HomeIconActive2 from "../../assets/images/sidebar/home-icon-active.png";
import SummaryIcon from "../../assets/images/sidebar/summary-icon.png";
import {
  TaskIcon,
  NotifyIcon,
  RuleIcon,
  CalenderIcon,
  TimeoffIcon,
  DriveIcon,
  AdsIcon,
  SearchConsoleIcon
} from "../../assets/images/feature-icons";
import { useTranslation } from "react-i18next";
import { useStore } from "../../redux/workflow/workflow_store";
import { changeSvgColor } from "../../utils/svgColorHelper";

type Props = {
  onMobileClose: () => void;
  openMobile: boolean | undefined;
};

// Interface cho Menu Item
interface MenuItem {
  id: number;
  title: string;
  description: string;
  icon?: string | React.ReactNode; // path đến icon image hoặc React component (optional)
  href?: string; // link đến trang (optional)
  supportUrl?: string;
}

const DashboardSidebar = ({ onMobileClose, openMobile }: Props) => {
  const location = useLocation();
  const [notExpanded, setNotExpanded] = useState<boolean>(false);
  // const [openCreatePJ, setOpenCreatePJ] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const valueWorkflow = useStore(state => state.value);

  // const [anchorElProject, setAnchorElProject] =
  //   useState<HTMLButtonElement | null>(null);
  // const [isHasPJ, setIsHasPJ] = useState<boolean>(false);
  const [userInfo, setUserInfo] = useState<ITokenPayload | null>(null);
  const [sideBarExpanded, setSideBarExpanded] = useState<boolean>(false);
  const [openWorkflowForm, setOpenWorkflowForm] = useState(false);
  const [expanded, setExpanded] = useState(true);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const [initialized, setInitialized] = useState(false);
  const [height, setHeight] = useState(window.innerHeight);
  const [openMenuModal, setOpenMenuModal] = useState(false);
  const [clickedChild, setClickedChild] = useState<{ parentIndex: number; childIndex: number } | null>(null);
  const { t } = useTranslation();

  const role = useApi<IFeaturePermission[]>({ isFetch: true });
  const projects = useAxios<IWorkflowByTypeResponse[]>({
    loading: "OnRequest"
  });

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  useEffect(() => {
    async function getUserInfo() {
      const user = await authTokens.getUser();
      user && setUserInfo(user);
    }
    getUserInfo();
    projects.request(WorkflowService.getAllWorkflows());
  }, []);

  useEffect(() => {
    projects.request(WorkflowService.getAllWorkflows());
  }, [valueWorkflow]);

  useEffect(() => {
    if (userInfo) {
      role.request(RoleService.getFeaturePemissionByUserId(userInfo.userId));
    }
  }, [userInfo]);

  // const sidebarData = useMemo(
  //   () => sidebarItems(role.data, projects.data).filter(s => s.code === "WORK" || s.code === "SUMMARY"),
  //   [role.data, projects.data]
  // );

  const { sidebarData, summaryData } = useMemo(() => {
    const items = sidebarItems(role.data, projects.data);

    // // DEBUG: Log projects data
    // console.log("=== Projects Data Debug ===");
    // console.log("projects.data:", projects.data);
    // console.log("sidebarItems result:", items);

    const workData = items.find(s => s.code === "WORK");
    // console.log("workData (WORK section):", workData);
    // console.log("workData?.children:", workData?.children);

    // if (workData?.children && workData.children.length > 0) {
    //   console.log("First child of WORK:", workData.children[0]);
    //   console.log("First child's children:", workData.children[0]?.children);
    //   if (workData.children[0]?.children && workData.children[0].children.length > 0) {
    //     console.log("First item in children:", workData.children[0].children[0]);
    //     console.log("First item icon:", (workData.children[0].children[0] as any)?.icon);
    //   }
    // }

    return {
      sidebarData: workData,
      summaryData: items.find(s => s.code === "SUMMARY" || s.code === "SUMMARY_ADMIN")
    };
  }, [role.data, projects.data]);

  // Auto-expand disabled - parent only expands when user clicks
  // No default active child when expanding
  /*
  useEffect(() => {
    if (sidebarData?.children?.[0]?.children) {
      const indicesToExpand = sidebarData.children[0].children
        .map((sidebar, index) => {
          // Check xem có child nào active không
          const hasActiveChild = sidebar.children?.some(child => {
            let isActive =
              sidebar.code === "project"
                ? location.search.includes(child.code!)
                : location.pathname
                  .split("/")
                  .splice(1)
                  .includes(child.code!.replace("/", ""));
            return isActive;
          });
          return hasActiveChild ? index : -1;
        })
        .filter(idx => idx !== -1);

      // SET expandedIndexes = ONLY parents có active children (xoá những cái cũ)
      setExpandedIndexes(indicesToExpand);
    }
  }, [location.pathname, location.search, sidebarData]);
  */

  // List 8 menu items - Lấy href động từ sidebarItems
  const menuItems: MenuItem[] = useMemo(() => {
    const items = sidebarItems(role.data, projects.data);

    const workItem = items.find(s => s.code === "WORK");
    const officeItem = items.find(s => s.code === "OFFICE");
    const timeoffItem = items.find(s => s.code === "TimeOff");
    const meetingItem = items.find(s => s.code === "Meeting");
    const driveItem = items.find(s => s.code === "DRIVE");
    // console.log("driveItem", driveItem?.children?.[0]?.href);
    const gadsItem = items.find(s => s.code === "GADS");

    return [
      {
        id: 1,
        title: t("Management.Task"),
        description: t("Management.ContentTask"),
        href: workItem?.children?.[0]?.href || ROUTE_PATH.WORKFLOWS_MANAGEMENT,
        icon: TaskIcon,
        supportUrl:
          "https://docs.google.com/document/d/13BpqSw4lWaSU9uiX5_go22210g47Gl4Nf17S5hfDgFc/edit?tab=t.diw80uno7j0p#heading=h.vffvce7hothu"
      },
      {
        id: 2,
        title: t("Management.InternalAnnouncements"),
        description: t("Management.ContentInternalAnnouncements"),
        href:
          officeItem?.children?.find(c => c.code === "docs")?.href ||
          ROUTE_PATH.DOCS,
        icon: NotifyIcon,
        supportUrl:
          "https://docs.google.com/document/d/13BpqSw4lWaSU9uiX5_go22210g47Gl4Nf17S5hfDgFc/edit?tab=t.i1uaowxba6gh#heading=h.vffvce7hothu"
      },
      {
        id: 3,
        title: t("Management.CompanyRules"),
        description: t("Management.ContentCompanyRules"),
        href:
          officeItem?.children?.find(c => c.code === "rules")?.href ||
          ROUTE_PATH.RULES,
        icon: RuleIcon,
        supportUrl:
          "https://docs.google.com/document/d/13BpqSw4lWaSU9uiX5_go22210g47Gl4Nf17S5hfDgFc/edit?tab=t.py72tozcxr1g#heading=h.vffvce7hothu"
      },
      {
        id: 4,
        title: t("Management.MeetingSchedule"),
        description: t("Management.ContentMeetingSchedule"),
        href: meetingItem?.children?.[0]?.href || ROUTE_PATH.BOOKING,
        icon: CalenderIcon,
        supportUrl:
          "https://docs.google.com/document/d/13BpqSw4lWaSU9uiX5_go22210g47Gl4Nf17S5hfDgFc/edit?tab=t.290fmqm75h9c#heading=h.vffvce7hothu"
      },
      {
        id: 5,
        title: t("Management.LeaveManagement"),
        description: t("Management.ContentLeaveManagement"),
        href: timeoffItem?.children?.[0]?.href || ROUTE_PATH.TIMEOFF,
        icon: TimeoffIcon,
        supportUrl:
          "https://docs.google.com/document/d/13BpqSw4lWaSU9uiX5_go22210g47Gl4Nf17S5hfDgFc/edit?tab=t.py72tozcxr1g#heading=h.vffvce7hothu"
      },
      {
        id: 6,
        title: "Linkco Drive",
        description: t("Management.ContentLinkCoDrive"),
        href: driveItem?.children?.[0]?.href || ROUTE_PATH.DRIVER,
        icon: DriveIcon,
        supportUrl:
          "https://docs.google.com/document/d/13BpqSw4lWaSU9uiX5_go22210g47Gl4Nf17S5hfDgFc/edit?tab=t.yq9n0h5pyklm#heading=h.vffvce7hothu"
      },
      {
        id: 7,
        title: "Google Tools",
        description: t("Management.GoogleToolContent"),
        href:
          gadsItem?.children?.find(c => c.code === ROUTE_PATH.GADS)?.href ||
          ROUTE_PATH.GADS,
        // icon: AdsIcon
        icon: SearchConsoleIcon,
        supportUrl:
          "https://docs.google.com/document/d/13BpqSw4lWaSU9uiX5_go22210g47Gl4Nf17S5hfDgFc/edit?tab=t.nflkmws5tckk#heading=h.vffvce7hothu"
      }
      // {
      //   id: 8,
      //   title: "Google Console",
      //   description: t("Management.ContentGoogleConsole"),
      //   href:
      //     gadsItem?.children?.find(c => c.code === ROUTE_PATH.GCSL)?.href ||
      //     ROUTE_PATH.GCSL,
      //   icon: SearchConsoleIcon
      // },
      // {
      //   id: 9,
      //   title: t("Management.CustomerSupport"),
      //   description: t("Management.ContentCustomerSupport"),
      //   href: ROUTE_PATH.ADMIN_CHAT,
      //   icon: <QuestionAnswerRounded sx={{ fontSize: 30, color: "#2C52B0" }} />
      // }
    ];
  }, [role.data, projects.data]);

  const validationSchema = Yup.object().shape({
    userName: Yup.string().required(`${"Please enter username"}`),
    password: Yup.string().required(`${"Please enter password"}`)
  }) as any;

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<any>({
    defaultValues: {
      userName: null,
      password: null
    },
    resolver: yupResolver(validationSchema)
  });

  const projectData: {
    name: string;
    domain: string;
    href: string;
    avatar: string;
  }[] = [
      {
        name: "Project Name fix-one -line fix-one-line fix-one-line fix-one-line fix-one-line",
        domain:
          "mikotech.vn fix-one -line fix-one-linef ix-one-linef ix-one-li nefix-one-line",
        href: "/",
        avatar: AvatarImage
      },
      {
        name: "Project Name",
        domain: "mikotech.vn",
        href: "/",
        avatar: AvatarImage
      },
      {
        name: "Project Name",
        domain: "mikotech.vn",
        href: "/",
        avatar: AvatarImage
      }
    ];

  const navigateSearch = useNavigateSearch();

  const handleCloseCreateWorkflow = () => {
    setOpenWorkflowForm(false);
  };

  const handleCreateWorkflowSuccess = () => {
    // reload();
    // setTabIndex(2);
    window.location.reload();
  };

  useEffect(() => {
    const handleResize = () => {
      // giả sử header cao 64px, footer cao 40px
      setHeight(window.innerHeight - 64 - 34 - 25);
    };

    handleResize(); // gọi ngay khi mount
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [expandedIndexes, setExpandedIndexes] = useState<number[]>([]);

  const toggleBox = (index: number, sidebar?: any) => {
    // Only toggle expand/collapse - no navigation
    setExpandedIndexes(
      prev =>
        prev.includes(index)
          ? prev.filter(i => i !== index) // đóng nếu đang mở
          : [...prev, index] // mở thêm
    );
  };

  const showModalMenu = () => {
    setOpenMenuModal(true);
  };

  const handleCloseMenuModal = () => {
    setOpenMenuModal(false);
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <>
      <PlanPopoverWrapper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <PlanBox />
      </PlanPopoverWrapper>

      <SidebarWrapper notexpanded={notExpanded}>
        <div className="sidebar-box">
          <div
            style={{ borderBottom: "1px solid #0441a5" }}
            className={`sidebar-box-expanded ${notExpanded ? "sidebar-box-not-expanded" : ""}`}
          >
            <Link to={ROUTE_PATH.WORKFLOWS_MANAGEMENT}>
              <Box
                component="img"
                src={LogoImage}
                alt="HEADER_LOGO"
                width={"150px"}
              />
            </Link>

            <Button
              className={`expanded-button ${notExpanded ? "notExpanded" : ""}`}
              size="large"
              variant="text"
              onClick={() => setNotExpanded(!notExpanded)}
            >
              {/* <ImageCustom
                src={ArrowLeft}
                alt="Arrow-Left"
                width={"24px"}
                height={"24px"}
              /> */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.3,16.78l4.11-4.11a1,1,0,0,0,0-1.41l-4-4"
                  stroke="#FFFFFF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
                <path
                  d="M8.7,7.22,4.59,11.33a1,1,0,0,0,0,1.41l4,4"
                  stroke="#FFFFFF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  fill="none"
                />
              </svg>
            </Button>
          </div>

          <Link
            style={{
              display: "block",
              padding: !notExpanded ? "0 20px" : "0px 15px",
              margin: "5px 0",
            }}
            to={"javascript:void(0)"}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <div
                style={{
                  display: "flex",
                  padding: "8px 0",
                  minWidth: "35px",
                  alignItems: "center",
                  borderRadius: "6px",
                  paddingLeft: "10px"
                }}
              >
                {!notExpanded && (
                  <div>
                    <div>
                      <Typography
                        variant="subtitle2"
                        fontSize="16px"
                        fontWeight={600}
                        sx={{
                          display: "inline-block",
                          color: "#FFFFFF",
                        }}
                      >
                        Menu
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Link>

          <Link
            onClick={() => showModalMenu()}
            style={{
              display: "block",
              padding: !notExpanded ? "0 20px" : "0px 15px",
              margin: "5px 0"
            }}
            to={"javascript:void(0)"}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between"
              }}
            >
              <div
                style={{
                  display: "flex",
                  padding: "8px 0",
                  minWidth: "35px",
                  alignItems: "center",
                  borderRadius: "6px",
                  paddingLeft: "10px"
                }}
              >
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.5 2.25H2.25V7.5H7.5V2.25Z" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.75 2.25H10.5V7.5H15.75V2.25Z" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M15.75 10.5H10.5V15.75H15.75V10.5Z" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M7.5 10.5H2.25V15.75H7.5V10.5Z" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

                {!notExpanded && (
                  <div>
                    <div>
                      <Typography
                        variant="subtitle2"
                        marginLeft="10px"
                        fontSize="14px"
                        fontWeight={600}
                        sx={{
                          display: "inline-block",
                          color: "#FFFFFF",
                        }}
                      >
                        {t("Management.Task")}
                      </Typography>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Link>

          <Link
            style={{
              display: "block",
              padding: !notExpanded ? "0 20px" : "0px 15px",
              margin: "5px 0"
            }}
            to={{
              pathname: sidebarData?.children && sidebarData?.children[0].href
            }}
          >
            <div
              className={
                sidebarData?.code === "WORK"
                  ? location.pathname.includes("Workflow_Management")
                    ? "workflow-management-active"
                    : ""
                  : ""
              }
              style={{
                display: "flex",
                minWidth: "35px",
                alignItems: "center",
                borderRadius: "6px",
                marginBottom: "0px",
                padding: "12px 10px",
                gap: "10px"
              }}
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.25 6.75L9 1.5L15.75 6.75V15C15.75 15.3978 15.592 15.7794 15.3107 16.0607C15.0294 16.342 14.6478 16.5 14.25 16.5H3.75C3.35218 16.5 2.97064 16.342 2.68934 16.0607C2.40804 15.7794 2.25 15.3978 2.25 15V6.75Z" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.75 16.5V9H11.25V16.5" stroke="#FFFFFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              {!notExpanded && (
                <Typography
                  variant="subtitle2"
                  fontSize="14px"
                  fontWeight={600}
                  sx={{
                    color: "#FFFFFF"
                  }}
                >
                  {t("Sidebar.Overview")}
                </Typography>
              )}
            </div>
          </Link>

          <Link
            style={{
              display: "block",
              padding: !notExpanded ? "0 20px" : "0px 15px",
              margin: "5px 0"
            }}
            to={{
              pathname:
                userInfo?.isSupperAdmin === "True" ||
                  userInfo?.role === "SuperAdmin"
                  ? ROUTE_PATH.SUMMARY_ADMIN
                  : summaryData?.children && summaryData?.children[0].href
            }}
          >
            <div
              className={
                summaryData?.code === "SUMMARY" || summaryData?.code === "SUMMARY_ADMIN"
                  ? location.pathname.includes("summary")
                    ? "summary-active"
                    : ""
                  : ""
              }
              style={{
                display: "flex",
                minWidth: "35px",
                alignItems: "center",
                borderRadius: "6px",
                marginBottom: "0px",
                padding: "12px 10px",
                gap: "10px"
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 22H2" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
                <path d="M21 22V14.5C21 13.6716 20.3284 13 19.5 13H16.5C15.6716 13 15 13.6716 15 14.5V22" stroke="#FFFFFF" strokeWidth="1.5" />
                <path d="M15 22V5C15 3.58579 15 2.87868 14.5607 2.43934C14.1213 2 13.4142 2 12 2C10.5858 2 9.87868 2 9.43934 2.43934C9 2.87868 9 3.58579 9 5V22" stroke="#FFFFFF" strokeWidth="1.5" />
                <path d="M9 22V9.5C9 8.67157 8.32843 8 7.5 8H4.5C3.67157 8 3 8.67157 3 9.5V22" stroke="#FFFFFF" strokeWidth="1.5" />
              </svg>

              {!notExpanded && (
                <Typography
                  variant="subtitle2"
                  fontSize="14px"
                  fontWeight={600}
                  sx={{
                    color: "#FFFFFF"
                  }}
                >
                  {t("Sidebar.Statistics")}
                </Typography>
              )}
            </div>
          </Link>

          <CreateWorkflowDialog
            open={openWorkflowForm}
            handleClose={handleCloseCreateWorkflow}
            handleSuccess={handleCreateWorkflowSuccess}
          />

          <SidebarGroupPanelWrapper
            className="hidden-scroll"
            sx={{ overflow: "auto", maxHeight: height }}
          >
            <ul
              hidden={!notExpanded}
              className={`sidebar-menu scrollbar-small`}
            >
              {sidebarData?.children &&
                sidebarData.children[0].children?.map(sidebar => (
                  <Accordion key={sidebar.code} defaultExpanded>
                    {notExpanded ? (
                      <>
                        <Divider sx={{ margin: "10px 0px" }} />
                      </>
                    ) : (
                      <AccordionSummary
                        sx={{
                          backgroundColor: "rgba(126,150,159,0.1)",
                          height: "28px",
                          fontSize: "12px",
                          fontWeight: 700,
                          color: "red"
                        }}
                        expandIcon={
                          !notExpanded && (
                            <ArrowDropDownRounded
                              sx={{ fontSize: "28px", color: "black" }}
                            />
                          )
                        }
                      >
                        <p
                          className={`sidebar-title ${notExpanded ? "notExpanded" : ""}`}
                        >
                          {!notExpanded && sidebar.title}
                        </p>
                      </AccordionSummary>
                    )}
                    <AccordionDetails>
                      <ul className="sidebar-children">
                        {sidebar.children &&
                          sidebar.children.map((child, idx) => {
                            let isActive =
                              sidebar.code === "project"
                                ? location.search.includes(child.code!)
                                : location.pathname
                                  .split("/")
                                  .splice(1)
                                  .includes(child.code!.replace("/", ""));
                            return (
                              <li
                                key={idx}
                                className={`children-item-notexpanded ${isActive ? "active" : ""}`}
                              >
                                <Tooltip
                                  title={!notExpanded ? "" : child?.title}
                                  placement="right"
                                >
                                  <Button
                                    style={{ padding: "8px 16px !important" }}
                                    onClick={() => {
                                      navigateSearch(child.href || "/", {
                                        id: child.search!,
                                        type: "board",
                                        tab: String(null)
                                      });
                                    }}
                                    startIcon={
                                      <Typography
                                        variant="subtitle2"
                                        style={{
                                          marginRight: "20px",
                                          backgroundColor: enumFromValue(
                                            child?.title
                                              .split(" ")
                                              .splice(0, 1)
                                              .map(e =>
                                                e.charAt(0).toUpperCase()
                                              ),
                                            EAlphabetColor
                                          ),
                                          width: "26px",
                                          height: "26px",
                                          borderRadius: "8px",
                                          alignContent: "center",
                                          fontSize: "10px"
                                        }}
                                      >
                                        {child?.title
                                          .split(" ")
                                          .splice(0, 2)
                                          .map(e => e.charAt(0))
                                          .join("")}
                                      </Typography>
                                    }
                                  >
                                    <p
                                      className={`${notExpanded ? "notExpanded" : ""} `}
                                    >
                                      {notExpanded ? "" : child?.title}
                                    </p>
                                  </Button>
                                </Tooltip>
                              </li>
                            );
                          })}
                      </ul>
                    </AccordionDetails>
                  </Accordion>
                ))}
            </ul>

            <ul
              hidden={notExpanded}
              className={`sidebar-menu scrollbar-small`}
              style={{ padding: "0 20px" }}
            >
              {sidebarData?.children &&
                sidebarData.children[0].children?.map((sidebar, index) => {
                  const childCount = sidebar.children?.length ?? 0;
                  const ITEM_HEIGHT = 33; // 1 item = 30px (chỉnh nếu bạn muốn 40)
                  const calculatedHeight = Math.max(
                    0,
                    childCount * ITEM_HEIGHT - ITEM_HEIGHT / 2
                  );
                  const maxAllowed = height; // từ state
                  const finalHeight = expandedIndexes.includes(index)
                    ? Math.min(calculatedHeight, maxAllowed)
                    : 0;

                  // Check xem có child nào active không
                  const hasActiveChild = sidebar.children?.some(child => {
                    let isActive =
                      sidebar.code === "project"
                        ? location.search.includes(child.code!)
                        : location.pathname
                          .split("/")
                          .splice(1)
                          .includes(child.code!.replace("/", ""));
                    return isActive;
                  });

                  return (
                    <Accordion
                      style={{ margin: "10px 0px" }}
                      key={sidebar.code}
                      expanded={expandedIndexes.includes(index)}
                      sx={{
                        "&::before": {
                          display: "none" // 👈 xoá line mặc định
                        },
                        boxShadow: "none", // 👈 bỏ shadow nếu có,,,
                        cursor: "pointer !important"
                      }}
                    >
                      {notExpanded ? (
                        <Divider sx={{ my: 1 }} />
                      ) : (
                        // Tự build header thay cho AccordionSummary
                        <Box
                          onClick={() => toggleBox(index, sidebar)}
                          sx={{
                            textTransform: "uppercase",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 1,
                            padding: "12px 10px",
                            // No highlight on parent - always transparent
                            backgroundColor: "transparent",
                            borderRadius: "6px",
                            // Always white color
                            color: "#FFFFFF",
                            cursor: "pointer !important",
                            transition: "all 0.2s ease"
                          }}
                        >
                          {/* Icon bên trái + title */}

                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1
                            }}
                          >
                            {/* Render SVG từ database */}
                            {(() => {
                              // Xác định SVG string từ sidebar
                              let iconSvg = "";

                              if (sidebar?.icon) {
                                // Nếu icon là object có property .default (INavItem format)
                                if (typeof sidebar.icon === "object" && "default" in sidebar.icon) {
                                  iconSvg = sidebar.icon.default;
                                }
                                // Nếu icon là string trực tiếp (SVG string từ database)
                                else if (typeof sidebar.icon === "string") {
                                  iconSvg = sidebar.icon;
                                }
                              }

                              // Nếu có icon SVG thì render
                              if (iconSvg) {
                                return (
                                  <Box
                                    component="div"
                                    dangerouslySetInnerHTML={{
                                      __html: changeSvgColor(iconSvg, "#FFFFFF")
                                    }}
                                    sx={{
                                      width: "18px",
                                      height: "18px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexShrink: 0,
                                      "& svg": {
                                        width: "18px",
                                        height: "18px",
                                        fill: "#FFFFFF",
                                        stroke: "#FFFFFF"
                                      },
                                      transition: "all 0.2s ease"
                                    }}
                                  />
                                );
                              }

                              return null;
                            })()}

                            <Typography
                              style={{ marginRight: "20px", color: "#FFFFFF" }}
                              sx={{
                                fontSize: 14,
                                textTransform: "capitalize",
                                fontWeight: "700",
                                color: "#FFFFFF",
                                overflow: "hidden",
                                display:
                                  "-webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp : 1;",
                                transition: "color 0.2s ease"
                              }}
                            >
                              {sidebar?.title}
                            </Typography>
                          </Box>

                          {/* Icon bên phải */}
                          {expandedIndexes.includes(index) ? (
                            <RemoveRounded
                              sx={{ fontSize: 20, color: "#FFFFFF" }}
                            />
                          ) : (
                            <KeyboardArrowDownIcon
                              sx={{ fontSize: 20, color: "#FFFFFF" }}
                            />
                          )}
                        </Box>
                      )}
                      <AccordionDetails>
                        <Box
                          className="sidebar-children"
                          sx={{
                            "&::after": {
                              content: '""',
                              top: "50px",
                              width: 1,
                              left: "20px",
                              // height: `${finalHeight}px`,
                              // height: "calc(100% - 36px - 30px)",
                              height: "calc(100% - 46px)",
                              bottom: "50%",
                              borderLeft: "1px solid",
                              position: "absolute",
                              borderColor: "rgba(255, 255, 255, 0.5)",
                              pointerEvents: "none"
                            }
                          }}
                        >
                          {sidebar.children &&
                            sidebar.children.map((child, idx) => {
                              // Active only when user explicitly clicked THIS specific child
                              // Check both parent index and child index
                              let isActive = clickedChild !== null &&
                                clickedChild.parentIndex === index &&
                                clickedChild.childIndex === idx;
                              return (
                                <Box
                                  key={idx}
                                  className={`children-item ${isActive ? "active" : ""}`}
                                  sx={{
                                    position: "relative",
                                    fontSize: "13px",
                                    cursor: "pointer",
                                    "&::after": {
                                      content: '""',
                                      width: 12,
                                      height: 24,
                                      left: "20px",
                                      borderLeft: "2px solid",
                                      borderBottom: "2px solid",
                                      borderBottomLeftRadius: "8px",
                                      borderTopLeftRadius: "0",
                                      borderBottomRightRadius: "0",
                                      position: "absolute",
                                      borderColor: "rgba(255, 255, 255, 0.5)",
                                      opacity: expandedIndexes.includes(index)
                                        ? 1
                                        : 0,
                                      visibility: 'hidden'
                                    }
                                  }}
                                >
                                  <Tooltip
                                    title={!notExpanded ? "" : child?.title}
                                    placement="right"
                                  >
                                    <Button
                                      disableRipple
                                      sx={{
                                        backgroundColor: isActive ? "#0A3170 !important" : "transparent !important",
                                        borderRadius: "6px",
                                        width: "100%",
                                        justifyContent: "flex-start",
                                        textTransform: "none",
                                        padding: "8px 12px",
                                        cursor: "pointer !important",
                                        "&:hover": {
                                          backgroundColor: isActive ? "#0A3170 !important" : "rgba(255,255,255,0.1) !important"
                                        }
                                      }}
                                      onClick={() => {
                                        setClickedChild({ parentIndex: index, childIndex: idx });
                                        navigateSearch(child.href || "/", {
                                          id: child.search!,
                                          type: "board",
                                          tab: String(null)
                                        });
                                      }}
                                    >
                                      <p
                                        style={{ fontWeight: "400", color: "#FFFFFF" }}
                                        className={`${notExpanded ? "notExpanded" : ""} `}
                                      >
                                        {notExpanded ? "" : child?.title}
                                      </p>
                                    </Button>
                                  </Tooltip>
                                </Box>
                              );
                            })}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
            </ul>
          </SidebarGroupPanelWrapper>
        </div>
      </SidebarWrapper>

      <Modal
        open={openMenuModal}
        onClose={handleCloseMenuModal}
        aria-labelledby="menu-modal-title"
        aria-describedby="menu-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 952,
            // height: 792,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 5,
            // overflow: 'auto',
            borderRadius: "16px",
            maxHeight: "98vh",
            overflowY: "scroll"
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
              mb: 3
            }}
          >
            <div>
              <Typography
                sx={{ fontSize: "24px", fontWeight: "700" }}
                component="h2"
              >
                {t("Management.Feature")}
              </Typography>

              <p style={{ fontSize: "14px" }}>
                {t("Management.SomePopularFeatures")}
              </p>
            </div>
            <Button
              onClick={handleCloseMenuModal}
              sx={{
                backgroundColor: "#F5F5F5",
                width: "26px !important",
                height: "26px !important",
                borderRadius: "50% !important",
                display: "flex !important",
                alignItems: "center !important",
                justifyContent: "center !important",
                "&:hover svg path": {
                  stroke: "#04214D !important"
                },
                "&:hover": {
                  backgroundColor: "#F5F5F5 !important"
                },
                "& svg path": {
                  transition: "all 0.3s ease-in-out"
                }
              }}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.5 4.5L4.5 13.5"
                  stroke="#7B7B7B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M4.5 4.5L13.5 13.5"
                  stroke="#7B7B7B"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Button>
          </Box>

          {/* Cards List */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              justifyContent: "flex-start"
            }}
          >
            {/* 8 Cards - 3 items mỗi hàng */}
            {menuItems.map(item => (
              <Card
                key={item.id}
                onClick={() => {
                  handleCloseMenuModal();
                  const href = item.href || "/";
                  // Check if external URL
                  if (href.startsWith("http://") || href.startsWith("https://")) {
                    window.open(href, "_blank");
                  } else {
                    navigateSearch(href, {
                      type: "board",
                      tab: String(null)
                    });
                  }
                }}
                sx={{
                  border: "1px solid rgba(237, 237, 237, 1)",
                  width: "calc(100% / 3 - 11px)",
                  minHeight: "201px",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  boxShadow: "none",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
                    borderColor: "#04214D"
                  }
                }}
              >
                <CardContent
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "25px 24px",
                    height: "100%",
                    gap: "16px"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center"
                    }}
                  >
                    {/* Icon ở giữa 62x62 */}
                    <Box
                      sx={{
                        width: 40,
                        height: 40,
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        mb: 2,
                        boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
                        marginBottom: "0.5rem !important"
                      }}
                    >
                      {item.icon ? (
                        typeof item.icon === "string" ? (
                          <Box
                            component="img"
                            src={item.icon}
                            alt={item.title}
                            sx={{ width: 40, height: 40 }}
                          />
                        ) : (
                          item.icon
                        )
                      ) : (
                        <Typography variant="h4" color="primary">
                          {item.id}
                        </Typography>
                      )}
                    </Box>

                    {/* Tên menu item */}
                    <Typography
                      color="#021C5E"
                      variant="h6"
                      component="div"
                      fontWeight={600}
                      fontSize={14}
                    >
                      {item.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="#676767"
                      sx={{ mt: 1 }}
                      fontSize={12}
                    >
                      {item.description.length > 30
                        ? item.description.substring(0, 60) + "..."
                        : item.description}
                    </Typography>
                  </div>

                  <div>
                    <Box
                      component="a"
                      href={item.supportUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        color: "#FFFFFF",
                        display: "inline-block",
                        textAlign: "center",
                        padding: "10px",
                        borderRadius: "8px",
                        // border: "1px solid #04214D",
                        cursor: "pointer",
                        transition: "all 0.3s ease-in-out",
                        backgroundColor: "#04214D",
                        textDecoration: "none",
                        "&:hover": {
                          backgroundColor: "#CFCFCF",
                          // borderColor: "#F7F7F7",
                          color: "#04214D",
                          fontWeight: "600",
                          boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)"
                        }
                      }}
                    >
                      {t("Common.UserGuide")}
                    </Box>
                  </div>
                </CardContent>
              </Card>
            ))}
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default DashboardSidebar;
